export default "__VITE_ASSET__CydGzD_N__"